<template>
  <div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#"></a>
            <router-link :to="{name: 'account-top-ups', params: {id: accountId}}">
              {{ $t('topUp.detailsView.backLinkLabel') }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> {{ topUpId }}</li>
        </ol>
      </nav>
    </div>
    <div>

    </div>

    <div>
      <card>
        <template slot="header">
          <h4 class="card-title d-inline">{{ $t('topUp.detailsView.title') }}</h4>
        </template>
        <template>
          <div v-loading="loading">
            <card v-if="topUp">
              <top-up-details :details="topUp"/>
              <div v-if="$auth.can({account_top_up: 'update'}, 'permissions') && topUp.type == 'payment_card'"
                   class="pt-3">
                <reduce-account-top-up-retries-btn :account-id="accountId" :top-up-id="topUpId"
                                                   :enabled="topUp.retries > 1"/>
                <span class="pl-3">
                <reinitiate-account-top-up-btn :account-id="accountId" :top-up-id="topUpId"
                                               :enabled="topUp.status == 'failed'"/>
              </span>
              </div>
              <div v-if="$auth.can({account_top_up: 'update'}, 'permissions') && topUp.type == 'one_off_top_up'"
                   class="pt-3">
                <verify-account-one-off-top-up-btn :account-id="accountId" :top-up-id="topUpId"
                                                   :enabled="topUp.status == 'initiated'"/>
              </div>
            </card>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import TopUpDetails from 'src/components/TopUp/TopUpDetails'
import ReinitiateAccountTopUpBtn from './ReinitiateAccountTopUpBtn'
import ReduceAccountTopUpRetriesBtn from './ReduceAccountTopUpRetriesBtn'
import VerifyAccountOneOffTopUpBtn from './VerifyAccountOneOffTopUpBtn.vue'
import {mapActions, mapState} from "vuex";

export default {
  name: "AccountTopUp",
  components: {
    TopUpDetails,
    ReinitiateAccountTopUpBtn,
    ReduceAccountTopUpRetriesBtn,
    VerifyAccountOneOffTopUpBtn
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    topUpId: {
      type: String,
      required: true
    },
  },
  methods: {
    ...mapActions(['LoadAccountTopUp']),
  },
  mounted() {
    // Loading user top-up data
    this.LoadAccountTopUp({accountID: this.accountId, topUpID: this.topUpId});
  },
  computed: {
    ...mapState({
      // darkTheme: state => state.app.darkMode,
      loading: state => state.account_top_up.loading,
      topUp: state => state.account_top_up.data,
    }),
  },
}
</script>

